import React from "react";
import {Route, Routes} from "react-router-dom";
import {DrawingTestPage} from "@/pages/drawing-test";

export const DrawingTestRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<DrawingTestPage />} />
        </Routes>
    );
};
